var AjaxFormModule = require('../../modules/ajaxForm');

var Page = {
    alias: 'loginUpdate',
    selectors: {
        form: '#loginUpdate',
        button: '#loginFormButton'
    },

    init: function () {
        Page.onFormSubmit()
    },

    onFormSubmit: function () {
        $(document).on('click', Page.selectors.button, function (e) {
            $(Page.selectors.form).submit();
        })

        $(document).on('touch', Page.selectors.button, function (e) {
            $(Page.selectors.form).submit();
        })

        $(document).on('submit', Page.selectors.form, function (e) {
            e.preventDefault();

            var form = $(this);
            var validator = AjaxFormModule.validate(form, AjaxFormModule.validationRules.auth.loginUpdate);
            if (form.valid()) {
                AjaxFormModule.submit(form);
            }
        })
    }
}

Page.init()
